"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _stringFormatter = require("../utils/stringFormatter");

var msPattern = /^ms-/;

var _default = function _default(string) {
  return (0, _stringFormatter.hyphenate)(string).replace(msPattern, '-ms-');
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/lib/style/hyphenateStyleName.js
// module id = 515
// module chunks = 0